import React from 'react';
import css from './ListingPage.module.css';

const SectionLastSeen = ({ lastSeenAt }) => {
  const getLabel = () => {
    if (!lastSeenAt) return 'Last seen over 14 days ago';

    const now = new Date();
    const seen = new Date(lastSeenAt);
    const diffMs = now - seen;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays <= 0) return 'Last seen today';
    if (diffDays === 1) return 'Last seen 1 day ago';
    if (diffDays <= 14) return `Last seen ${diffDays} days ago`;
    return 'Last seen over 14 days ago';
  };

  return (
    <span className={css.lastSeenBadge}>
      <span className={css.lastSeenBadgeDot} />
      {getLabel()}
    </span>
  );
};

export default SectionLastSeen;
